import { useQuery } from '@apollo/client'
import { SearchableCombobox, TSearchable } from '../base/combobox'
import { ClientTypeSelectorQuery, SelectedClientTypeSelectorQuery } from './__generated__/selector_query'
import { Query, SelectedQuery } from './selector_query'
import { dedupe } from '@/helpers/dedupe'
import { useCombobox } from '@/helpers/useCombobox'

type ClientType = SelectedClientTypeSelectorQuery['clientTypes']['nodes'][0]

interface Props {
  value: string
  onChange: (value: TSearchable | null) => void
  invalid: boolean
}

export const Selector = ({ value, onChange, invalid }: Props) => {
  const { data: selectedData } = useQuery<SelectedClientTypeSelectorQuery>(
    SelectedQuery,
    { variables: { id: value || 'blank' } }
  )
  const { data, loading, refetch, fetchMore } = useQuery<ClientTypeSelectorQuery>(Query)

  const { pageInfo, items } = useCombobox<ClientType>({
    pageInfo: data?.clientTypes.pageInfo,
    querySelected: selectedData?.clientTypes.nodes[0],
    queryCollection: data?.clientTypes.nodes,
    buildSearchable: item => ({
      id: item.id,
      name: item.name,
    })
  })

  return (
    <SearchableCombobox
      data={items}
      includeBlank={false}
      invalid={invalid}
      loading={loading}
      moreToFetch={pageInfo.current?.hasNextPage}
      refetch={refetch}
      searchField="nameCont"
      value={items.find(d => d.id == value) || { id: '', name: '' }}
      fetchMore={() => fetchMore({
        variables: { after: pageInfo.current?.endCursor },
        updateQuery(previousData, { fetchMoreResult }) {
          if (Object.keys(previousData).length === 0) return fetchMoreResult
          fetchMoreResult.clientTypes.nodes = dedupe([
            ...previousData.clientTypes.nodes,
            ...fetchMoreResult.clientTypes.nodes
          ])

          return { ...fetchMoreResult }
        }
      })}
      onChange={onChange}
    />
  )
}
